import { useEffect } from "react";

import { isCoach } from "@/components/helpers/workspace/permissions";
import { useStaffCustomerLazyQuery } from "@/graphql";

interface UseStaffCustomerProps {
  userId?: string;
  currentWorkspaceId: string;
}

export const useStaffCustomer = ({
  userId,
  currentWorkspaceId,
}: UseStaffCustomerProps) => {
  const [fetch, { data, loading }] = useStaffCustomerLazyQuery({
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (isCoach() && userId) {
      fetch({
        variables: {
          customerId: userId,
          workspaceId: currentWorkspaceId,
        },
      });
    }
  }, [userId, currentWorkspaceId]);

  return { data, loading };
};
